import React from 'react'
import tw, { styled } from 'twin.macro'


const Controls = ({ children, ...props }) => (
    <Style {...props}>
        { children }
    </Style>
)
export default Controls


const Style = styled.div`
    ${tw `items-center gap-x-2 lg:ml-8 flex relative`}

    button {
        ${tw `
            text-gray-900
            hover:text-primary
            outline-none
            focus-visible:text-orange
            w-8
            h-8
        `}
    }

    button {
        ${tw `
            appearance-none
            cursor-pointer
            rounded-none
            bg-transparent
            p-0
            border-none
        `}
    }

    a {
        ${tw `hidden lg:block`}
    }


    svg {
        ${tw `[strokeWidth:3px] w-full h-full`}
    }
`